
export default {
    code: "bg-gray-100 font-mono text-sm p-2 pl-12 block rounded-md",

    heading: {
        h1: "text-2xl font-normal mb-3 text-gray-900",
        h2: "text-sm font-bold uppercase text-gray-500 mt-2 mb-2",
        h3: "text-base font-semibold mt-2 mb-2",
        h4: "text-sm font-semibold mt-1 mb-1",
        h5: "text-sm text-gray-600 mt-1 mb-1",
    },

    image: "max-w-full rounded-md my-2",

    link: "text-blue-600 underline hover:text-blue-800",

    list: {
        listitem: "mx-8 my-2",
        nested: {
            listitem: "list-none",
        },
        ol: "ml-5 list-decimal",
        ul: "ml-5 list-disc",
    },

    paragraph: "mb-2",

    placeholder: "text-gray-400",

    quote:
        "border-l-4 border-gray-300 pl-4 text-gray-500 italic my-2",

    text: {
        bold: "font-bold",
        code: "bg-gray-100 font-mono px-1 py-[1px] rounded",
        hashtag: "text-blue-500",
        italic: "italic",
        overflowed: "truncate",
        strikethrough: "line-through",
        underline: "underline",
        underlineStrikethrough: "underline line-through",
    },
};